import BasketViewSFC from "./BasketView.vue";
export const BasketView = BasketViewSFC;
